import { call, put } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';
import config from '../../../config';
import request from 'superagent';

//v4
export function* getFieldAvailabilityRulesSaga() {
    yield* takeEvery("SCHEDULE_MANAGER/FIELD_AVAILABILITY_RULES/FETCH", function* (action) {

        try {
            const result = yield call(({ idSeason }) => {
                return request.get(`${config.apiEndpoint}/api/v4/schedule/rules/fields/${idSeason}`)
                    .set('Authorization', `Bearer ${localStorage.getItem('sportslogic.authtoken')}`)
                    .then((data) => JSON.parse(data.text));
            }, action);

            if (result && result.success) {
                yield put({ type: 'SCHEDULE_MANAGER/FIELD_AVAILABILITY_RULES/SET', rules: result.rules });
            } else {
                yield put({ type: 'SCHEDULE_MANAGER/FIELD_AVAILABILITY_RULES/FETCH_FAILED', result });
            }
        } catch (e) {
            yield put({ type: 'SCHEDULE_MANAGER/FIELD_AVAILABILITY_RULES/FETCH_FAILED', e });
        }
    });
}

//v4
export function* associateFieldAvailabilityRuleWithFlightSaga() {
    yield* takeEvery("SCHEDULE_MANAGER/FIELD_AVAILABILITY_RULES/ASSOCIATE_WITH_FLIGHT", function* (action) {
        const result = yield call(function () {
            return request.post(`${config.apiEndpoint}/api/v4/flights/associate/field/${action.idFlight}/${action.idRule}`)
                .set('Authorization', `Bearer ${localStorage.getItem('sportslogic.authtoken')}`)
                .then((data) => JSON.parse(data.text));
        });

        if (result && result.success) {
            // TODO ?
            yield put({
                type: 'DIVISIONS/ASSOCIATE/FIELD_AVAILABILITY',
                idFlight: result.IdFlight,
                idRule: result.IdRule,
                idAssociation: result.idAssociation
            });
        }
    });
}

//v4
export function* removeFieldAvailabilityRuleAssociationFromFlight() {
    yield* takeEvery("SCHEDULE_MANAGER/FIELD_AVAILABILITY_RULES/REMOVE_ASSOCIATION_FROM_FLIGHT", function* (action) {
        const result = yield call(function () {
            return request.del(`${config.apiEndpoint}/api/v4/flights/remove/field/${action.idRuleAssociation}`)
                .set('Authorization', `Bearer ${localStorage.getItem('sportslogic.authtoken')}`)
                .then((data) => JSON.parse(data.text));
        });

        if (result && result.success) {
            // TODO ?
            yield put({ type: 'DIVISIONS/REMOVE_ASSOCIATION/FIELD_AVAILABILITY', idAssociation: action.idRuleAssociation });
        }
    });
}
